import api from './api';

interface SubjectResponse {
  subjects: string[];
}

export const getSubjects = async (): Promise<SubjectResponse> => {
  try {
    const response = await api.get('/subject/get');
    return response.data;
  } catch (error) {
    console.error('Error fetching subjects:', error);
    throw new Error('Failed to fetch subjects');
  }
};

export const addSubject = async (subject: string): Promise<void> => {
  try {
    await api.post('/subject/add', { subject });
  } catch (error) {
    console.error('Error adding subject:', error);
    throw new Error('Failed to add subject');
  }
};

export const deleteSubject = async (subject: string): Promise<void> => {
  try {
    await api.delete('/subject/delete', { data: { subject } });
  } catch (error) {
    console.error('Error deleting subject:', error);
    throw new Error('Failed to delete subject');
  }
};